import contains from 'dom-helpers/query/contains';
export function shouldRootCloseNodeForSelection(selection, node) {
  if (!node) {
    return false;
  }

  return !contains(node, selection.anchorNode) && !contains(node, selection.focusNode);
}
export function shouldRootCloseNodeForEvent(event, node) {
  if (!node) {
    return false;
  }

  return !contains(node, event.target);
}
export function shouldRootCloseEditorForEvent(event, editor) {
  if (!editor.el) {
    return false;
  }

  return shouldRootCloseNodeForEvent(event, editor.el.parentNode);
}